<template>
    <transition name="fade">
        <div class="spinner">
            <div  v-bind:class="[size, 'spinner-border']" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </transition>
</template>


<script>
    export default {
        name: 'spinner',
        props: {
            size: {
                type: String,
                default: 'regular'
            },
        }
    }
</script>
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .spinner {
        position: absolute;
        z-index: 990;
        height: 100%;
        width: 100%;
        overflow: visible;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .spinner-border {
        z-index: 990;
        position: absolute;
        height: 38px;
        width: 38px;
        top: 50%;
        left: 50%;
        margin-left: -19px;
        margin-top: -19px;

        &.small{
            height: 18px;
            width: 18px;
            margin-left: -9px;
            margin-top: -9px;
        }
    }
</style>
